import Layout from '@layout/Index'

export const userOrderStat = [
  {
    path: '/user-order-stat',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "user_order_stat_table" */ './pages/UserOrderStatTable.vue'),
        name: '条件搜索添加标签列表',
        meta: {
          title: '条件搜索添加标签列表',
        },
      },
      {
        path: 'detail/:userid',
        component: () => import(/* webpackChunkName: "user_order_stat_detail" */ './pages/UserOrderStatDetail.vue'),
        name: '用户统计数据详情',
        meta: {
          title: '用户统计数据详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-order-stat/userOrderStat.route.js